export default __webpack_public_path__ + "static/logo-d622b97f54bf252550e68d9139f30915.png";